/**
 * TurnTransition Component
 *
 * Displays a transition screen between players in pass-and-play mode.
 * Hides all card information from the previous player and prompts
 * the next player to confirm they are ready.
 */

import React, { useCallback } from 'react';
import './TurnTransition.css';

export interface TurnTransitionProps {
  nextPlayerName: string;
  nextPlayerIndex: number;
  onReady: () => void;
}

const TurnTransition: React.FC<TurnTransitionProps> = ({
  nextPlayerName,
  nextPlayerIndex,
  onReady,
}) => {
  const handleReady = useCallback(() => {
    onReady();
  }, [onReady]);

  // Player colors for visual distinction
  const playerColors = ['#4a90e2', '#50c878', '#e8a838', '#7b68ee'];
  const playerColor = playerColors[nextPlayerIndex % playerColors.length];

  return (
    <div className="turn-transition" role="dialog" aria-label="Turn transition">
      <div className="turn-transition__overlay" />
      <div className="turn-transition__content">
        <div
          className="turn-transition__avatar"
          style={{ '--player-color': playerColor } as React.CSSProperties}
        >
          <span className="turn-transition__avatar-text">
            {nextPlayerName.charAt(0).toUpperCase()}
          </span>
        </div>

        <h2 className="turn-transition__title">
          {nextPlayerName}'s Turn
        </h2>

        <p className="turn-transition__message">
          Pass the device to {nextPlayerName}
        </p>

        <p className="turn-transition__privacy-note">
          Previous player's cards are hidden
        </p>

        <button
          className="turn-transition__ready-btn"
          onClick={handleReady}
          autoFocus
          aria-label={`${nextPlayerName} is ready to play`}
        >
          I'm Ready
        </button>
      </div>
    </div>
  );
};

export default TurnTransition;
